import { render } from "./Footer1.vue?vue&type=template&id=5d10e39a"
import script from "./Footer1.vue?vue&type=script&lang=js"
export * from "./Footer1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__